import { Skeleton, SkeletonGroup } from '@mokoboko/components';

// The picker runs with `fixedWeeks`, so every month draws six rows whatever it
// actually spans.
const DAY_CELL_COUNT = 42;

// The class page's whole booking block: the "Pick a time" heading over the
// calendar. The instructor filter depends on the response, so it gets no bar.
export const ClassCalendarSkeleton = () => (
  <div className="flex flex-col gap-4">
    <Skeleton text="body-lg" width={112} />
    <CalendarSkeleton />
  </div>
);

export const CalendarSkeleton = () => {
  return (
    <div className="flex flex-wrap gap-4 md:gap-8">
      {/* Calendar grid */}
      <div className="relative min-w-0 flex-1 basis-full md:basis-[290px]">
        <div className="pt-3">
          {/* Nav: prev / month label / next */}
          <SkeletonGroup gap="gap-0" align="center">
            <Skeleton width={40} height={40} className="!rounded-xl" />
            <div className="flex flex-1 justify-center">
              <Skeleton text="body" width={170} />
            </div>
            <Skeleton width={40} height={40} className="!rounded-xl" />
          </SkeletonGroup>

          {/* Weekday headers + day cells */}
          <div className="grid grid-cols-7 gap-x-1.5 pt-4 sm:gap-x-0 md:gap-x-1">
            {Array.from({ length: 7 }).map((_, i) => (
              <div
                key={`wh-${i}`}
                className="flex h-10 items-center justify-center"
              >
                <Skeleton width={32} height={16} />
              </div>
            ))}
            {Array.from({ length: DAY_CELL_COUNT }).map((_, i) => (
              <div
                key={`ds-${i}`}
                className="flex items-center justify-center py-1 sm:px-1 sm:py-1.5"
              >
                <Skeleton
                  width="100%"
                  height={44}
                  className="!rounded-[10px]"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Time slots */}
      <div className="min-w-0 flex-1 basis-full md:min-w-[260px] md:basis-[260px] md:self-start">
        <div className="flex items-center justify-center pb-3 pt-2.5 md:pb-4 md:pt-0 lg:pt-5">
          <Skeleton text="body" width={160} />
        </div>
        <div className="grid grid-cols-3 gap-3 pb-[72px] pt-1 md:py-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton
              key={`ss-${i}`}
              width="100%"
              height={62}
              className="!rounded-xl"
            />
          ))}
        </div>
      </div>
    </div>
  );
};
